/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "delivery-pricing-bulk-import-validation",
	props: ["canSubmit", "dateToBeEffective", "productsToImport", "orderTypeId"],
	emits: ["confirmationSubmitComplete", "effectiveDateChange"],
	data() {
		return {
			products: [],
			effectiveDate: new Date(),
			effectiveDateError: null,
			productsErrorMessage: null,
			initialiseDate: true,
			productHeadings: [
				{
					text: "Product Code",
					field: "productCode"
				},
				
				{
					text: "Product Name",
					field: "product"
				},
				{
					text: "Zone",
					field: "zone"
				},
				{
					text: "Price",
					field: "priceAsString"
				}
			],
			zones: [],
			productTypes: [],
			productType: {},
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive"
			},
			productAddEditFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "addEditProductModal",
				heading: "Add Product",
				product: {
					productId: null,
					name: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					price: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					erpCode: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					effectiveDate: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					allowCollection: false,
					allowDelivery: false,
					allowCollectionDeliveryErrorMessage: null,
					allowCollectionDeliveryHasError: false
				},
				isUpdate: false
			},
			productMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markProductAsActiveInactiveModal",
				heading: "Mark Product As Active/Inactive",
				isActive: null
			},
			filterStateChanged: false,
			filter:{
				zoneId: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getProductsForImport(){
			console.log("products", this.products);
			for(let i = 0; i < this.products.length; i++){
				if(this.orderTypeId === orderHelper.orderType.exTank){
					this.products[i].priceAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.products[i].price);	
				}
				else {
					this.products[i].priceAsString = currencyHelper.numberToCurrency(this.products[i].price);
				}
			}
			//this.products = dataTableHelper.castFieldValues(this.products);
		},
		onEffectiveDateSelect(date){
			if(this.effectiveDate !== date){
				this.effectiveDate = date;
				this.initialiseDate = false;
				this.$emit("effectiveDateChange", this.effectiveDate);
			}
			
			console.log("date", date);
			
		},
		confirmImport(){
			var productZonePriceBulkImport = [];
			for(var i = 0; i < this.products.length; i++){
				var obj = {
					zoneProductBasePriceId: 0,
					zone: this.products[i].zone,
					product: this.products[i].product,
					productCode: this.products[i].productCode,
					price: this.products[i].price
				};
				productZonePriceBulkImport.push(obj);
			}
			let request = {
				effectiveDate: this.effectiveDate,
				productZonePriceBulkImport: productZonePriceBulkImport
			};
			productService.validateZoneProductBasePriceBulkImport(request).then(
				successResponse =>{
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						var confirmation = {
							success: true,
							effectiveDate: this.effectiveDate,
							productZonePriceBulkImport: productZonePriceBulkImport
						};
						if(successResponse.data.zoneProductBasePriceBulkImportValidationResponse.valuesAreValid){
							confirmation.success = true;
							this.$emit("confirmationSubmitComplete", confirmation);
						}
						else{
							confirmation.success = false;
							this.$emit("confirmationSubmitComplete", confirmation);
							this.effectiveDateError = successResponse.data.zoneProductBasePriceBulkImportValidationResponse.effectiveDateValidationResponse.message;
							this.productsErrorMessage = successResponse.data.zoneProductBasePriceBulkImportValidationResponse.zonePricingValidationResponse.message;
						}
					}
				},
				errorResponse =>{
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		}
	},
	mounted: function () {
		
	},
	watch:{
		canSubmit:{
			handler: function (){
				if(this.canSubmit){
					this.confirmImport();
				}
			},
			immediate: true,
			deep: true
		},
		productsToImport:{
			handler: function (){
				if(this.productsToImport){
					console.log("productsToImport", this.productsToImport);
					this.products = this.productsToImport;
					this.getProductsForImport();
				}
			},
			immediate: true,
			deep: true
		},
		dateToBeEffective:{
			handler: function (){
				console.log("dateToBeEffective", this.dateToBeEffective);
				if(this.dateToBeEffective){
					this.initialiseDate = true;
					this.effectiveDate = new Date(this.dateToBeEffective);
					console.log("effectiveDate", this.effectiveDate);
				}
				else{
					this.effectiveDate = new Date();
				}
			},
			immediate: true,
			deep: true
		}
	}
};